import { Route, Routes } from "react-router-dom";
import PrivateRoute from "../context/PrivateRoute";
import { routes } from "./routes";

const AppRoutes = () => {
  const renderRoutes = (routes: any[]) => {
    return routes.map((route, index) => {
      if (route.private) {
        return (
          <Route
            path={route.path}
            element={
              <PrivateRoute>
                <route.component />
              </PrivateRoute>
            }
            key={index}
          />
        );
      }

      return (
        <Route path={route.path} element={<route.component />} key={index} />
      );
    });
  };

  return <Routes>{renderRoutes(routes)}</Routes>;
};

export default AppRoutes;
